import { useNavigate } from 'react-router-dom';
import { LoadingSymbol } from '.';
import './Button.css';

export function Button(
   props: Readonly<{
      title?: string;
      children?: any;
      type: 'transparent' | 'green' | 'white' | 'green-big' | 'white-big' | 'close' | 'transparent-big';
      fullWidth?: boolean;
      nowrap?: boolean;
      loading?: boolean;
      titleOnHover?: string;
      className?: string;
      small?: boolean;
      to?: string;
      [key: string]: any;
   }>
) {
   const { title, type, fullWidth, nowrap, loading, className, titleOnHover, to, small, children, ...overflowProps } = props;
   const navigate = useNavigate();

   return (
      <button
         onClick={() => {
            if (props.to) {
               navigate(props.to);
            }
            if (props.onClick) {
               props.onClick();
            }
         }}
         className={`
                    ${type}
                    ${fullWidth ? 'w-100' : ''}
                    ${nowrap ? 'nowrap' : ''}
                    ${loading ? 'loading' : ''}
                    ${className || ''}
                     ${small ? 'small' : ''}
                `}
         {...overflowProps}
         disabled={loading || overflowProps.disabled}>
         {!loading && (
            <div className="flex items-center justify-center gap-2">
               {children}
               {title && <p>{title}</p>}
            </div>
         )}

         <div className="loading-container flex justify-center items-center">
            {loading && (
               <LoadingSymbol
                  dark={['white', 'white-big', 'green', 'green-big'].includes(type)}
                  size={18}
               />
            )}
         </div>
      </button>
   );
}
